import {toISODate, toInt} from "../../../../utils/convert-fields"

export const mapDataAniversarioPayload = (tableData = [], cetip, versaoDocumento) => {
    return tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map((column) => {
            return {
                IDFluxoEvento: toInt(column.IDFluxoEvento) ?? null,
                DataReferencia: toISODate(column.DataReferencia),
                CETIP: cetip,
                VersaoDocumento: versaoDocumento,
                DataAniversarioAnterior: toInt(column.DataAniversarioAnterior),
                DataAniversario: toISODate(column.DataAniversario),
                CorrigeDataAniversario: column.CorrigeDataAniversario,
                AniversarioPeriodico: column.AniversarioPeriodico,
            }
        })
}